import { useEffect, useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, apps } from '@/mocks/data';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const [activeSlug, setActiveSlug] = useState(slug || 'saishi-zhibo');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const activeCategory = categories.find((c) => c.slug === activeSlug);
  const filteredApps = apps.filter((a) => a.category === activeSlug);

  useEffect(() => {
    const catName = activeCategory?.name || '分类';
    document.title = `${catName}App推荐 | 体育App下载指南2024`;
  }, [activeCategory]);

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <section className="py-10 md:py-14 px-6 md:px-10 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-accent-600 transition-colors whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium whitespace-nowrap">{activeCategory?.name || '分类'}</span>
            </nav>

            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              {activeCategory?.name}App推荐
            </h1>
            <p className="text-sm text-foreground-600 max-w-2xl">
              {activeCategory?.description}
            </p>
          </div>
        </section>

        <section className="py-8 px-6 md:px-10 bg-background-50 border-b border-background-200">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-accent-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-950'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 px-6 md:px-10 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {filteredApps.map((app) => (
                <Link
                  key={app.id}
                  to={`/article/${app.articleId}`}
                  className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-accent-200 transition-all duration-200 cursor-pointer"
                  data-product-shop=""
                >
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 rounded-2xl overflow-hidden flex-shrink-0 bg-background-100">
                      <img
                        src={app.icon}
                        alt={app.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <h3 className="font-semibold text-foreground-950 text-base group-hover:text-accent-600 transition-colors whitespace-nowrap">
                          {app.name}
                        </h3>
                        <span className="text-xs text-accent-500 flex items-center gap-0.5 whitespace-nowrap">
                          <i className="ri-star-fill text-xs"></i>
                          {app.rating}
                        </span>
                      </div>
                      <p className="text-xs text-foreground-600 line-clamp-2 mb-2 leading-relaxed">
                        {app.description}
                      </p>
                      <div className="flex items-center gap-3 text-xs text-foreground-500">
                        <span className="whitespace-nowrap">
                          <i className="ri-download-2-line mr-1"></i>
                          {app.downloads}
                        </span>
                        <span className="whitespace-nowrap">{app.price}</span>
                        <span className="whitespace-nowrap">
                          {app.platform.join(' / ')}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1.5 mt-4">
                    {app.features.map((f) => (
                      <span
                        key={f}
                        className="px-2 py-0.5 bg-accent-50 text-accent-700 rounded-md text-xs whitespace-nowrap"
                      >
                        {f}
                      </span>
                    ))}
                  </div>
                </Link>
              ))}
            </div>

            {filteredApps.length === 0 && (
              <div className="text-center py-16">
                <p className="text-foreground-500 text-sm">该分类暂无App</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}